module.exports = __webpack_public_path__ + "assets/images/EUR100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR100.png
// module id = 1364
// module chunks = 1